import {useEffect} from 'react';
import type {PatternAiAction, PatternCapabilities} from '../types';
import {getPatternCapabilities} from '../../../../services/patternRecognitionService';

interface AuthState {
    ready: boolean;
    isAuthenticated: boolean;
    isPoc: boolean;
}

export function usePatternCapabilities(
    dispatch: (action: PatternAiAction) => void,
    auth: AuthState,
) {
    useEffect(() => {
        if (!auth.ready) return;

        if (!auth.isAuthenticated && !auth.isPoc) {
            dispatch({type: 'CAPABILITIES_REQUEST_FAILED'});
            return;
        }

        let cancelled = false;
        dispatch({type: 'CAPABILITIES_REQUEST_STARTED'});

        getPatternCapabilities(auth.isPoc).then((caps) => {
            if (cancelled) return;
            if (null == caps) {
                dispatch({type: 'CAPABILITIES_REQUEST_FAILED'});
                return;
            }
            dispatch({
                type: 'CAPABILITIES_REQUEST_SUCCEEDED',
                payload: caps as PatternCapabilities,
            });
        }).catch(() => {
            if (!cancelled) dispatch({type: 'CAPABILITIES_REQUEST_FAILED'});
        });

        return () => {
            cancelled = true;
        };
    }, [auth.ready, auth.isAuthenticated, auth.isPoc, dispatch]);
}
